'use strict';

import {
	RESET_STATE,
	UPDATE_BATCH_FORM,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	SET_POS_CONFIGURATION_VERSION,
	UPDATE_POS_CONFIGURATION_VERSION,
	EDIT_BATCH_LIST_ITEMS,
	ADD_BATCH_LIST_DUPLICATE,
	REVERT_BATCH_LIST_ITEM,
	SET_BATCH_LIST_ITEM_LOADING,
} from './posConfigurationVersions.actions';

const defaultState = {
	data: {
		defaultPosConfigurationVersion: {},
		batchFormData: {
			state: {
				value: 'Draft',
				label: 'Draft',
			},
		},
		batchListData: [],
		batchListDataDuplicate: [],
		batchListItemLoadingId: null,
	},
};

function reducer(state = defaultState, action) {
	const { payload, type } = action;

	switch (type) {
	case UPDATE_BATCH_FORM: {
		return {
			...state,
			data: {
				...state.data,
				batchFormData: {
					...state.data.batchFormData,
					...payload,
				},
			},
		};
	}

	case ADD_BATCH_LIST: {
		return {
			...state,
			data: {
				...state.data,
				batchListData: payload,
			},
		};
	}

	case ADD_BATCH_LIST_DUPLICATE: {
		return {
			...state,
			data: {
				...state.data,
				batchListDataDuplicate: payload,
			},
		};
	}

	case REVERT_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchListData: state.data.batchListData.map((entry) => {
					if (entry.identifier === payload.identifier) {
						// find the original entry in duplicate array
						const og = state.data.batchListDataDuplicate.find(
							(ogEntry) => ogEntry.identifier === entry.identifier
						);
						return {
							...og,
							rowEdited: false,
						};
					}

					return entry;
				}),
			},
		};
	}

	case EDIT_BATCH_LIST_ITEMS: {
		return {
			...state,
			data: {
				...state.data,
				batchListData: state.data.batchListData.map((entry) => ({
					...entry,
					...payload,
					rowEdited: true,
				})),
			},
		};
	}

	case EDIT_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchListData: state.data.batchListData.map((entry) => {
					if (entry.identifier === payload.identifier)
						return {
							...payload,
							rowEdited: true,
						};
					return entry;
				}),
			},
		};
	}

	case REMOVE_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchListData: state.data.batchListData.filter(
					(entry) => entry.identifier !== payload
				),
			},
		};
	}

	case SET_POS_CONFIGURATION_VERSION: {
		return {
			...state,
			data: {
				...state.data,
				defaultPosConfigurationVersion: payload,
			},
		};
	}

	case UPDATE_POS_CONFIGURATION_VERSION: {
		return {
			...state,
			data: {
				...state.data,
				defaultPosConfigurationVersion: {
					...state.data.defaultPosConfigurationVersion,
					...payload,
				},
			},
		};
	}

	case SET_BATCH_LIST_ITEM_LOADING: {
		return {
			...state,
			data: {
				...state.data,
				batchListItemLoadingId: payload,
			},
		};
	}

	case RESET_STATE: {
		return defaultState;
	}

	default:
		// never return default state in default case, Filip!!!
		return state;
	}
}

export default reducer;
